import img1 from "../assets/images/MyGharana.png"
import img2 from "../assets/images/Razorpay.png"
import img3 from "../assets/images/IconTracker.png"
import img4 from "../assets/images/NotesApp.png"

export default [
        {
            "cover": img1,
            "title": "MyGharana",
            "description": "React, JSX, CSS3, Tailwind, ContextAPI",
            "url": "https://mygharana.netlify.app/"
        },
        {
            "cover": img2,
            "title": "Razorpay Clone",
            "description": "Tailwind, CSS3, Linear-Animation",
            "url": "https://myrazorpayui.netlify.app/"
        },
        {
            "cover": img3,
            "title": "Icon",
            "description": "React, JSX, CSS3, Redux",
            "url": "https://tracker.icon.community/"
        },
        {
            "cover": img4,
            "title": "Notes",
            "description": "React, JSX, CSS3",
            "url": "https://github.com/Aviraj-Singh/My-Notes-App"
        },
        // {
        //     "cover": "/portfolio/1/one.png",
        //     "title": "GGWP",
        //     "description": "React, JSX, Tailwind, Jest",
        //     "url": "http://google.com"
        // }
    ]